var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkChain = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.12249 10.3776L10.3775 5.12275M3.15223 7.09321L1.83848 8.40691C0.38736 9.85798 0.387079 12.2106 1.8382 13.6617C3.28932 15.1128 5.64234 15.1128 7.09346 13.6617L8.40665 12.348M7.0929 3.15198L8.40665 1.83828C9.85777 0.387201 12.2104 0.387261 13.6615 1.83834C15.1126 3.28941 15.113 5.64201 13.6618 7.09309L12.3482 8.40679",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgLinkChain;